import styles from '../../../../../common/preview-block/Preview.module.scss';
import React from 'react';

const Preview = () => {
  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <div
      role='dialog'
      onKeyDown={(e) => e.stopPropagation()}
      className={styles.template_preview_container}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <p>
        The Suppliers folder helps businesses establish strong and legally sound agreements with
        service providers, contractors, manufacturers, and collaborators. Using these templates
        protects businesses from payment disputes, IP theft, unclear obligations, and liability
        exposure. These agreements also support enforceable terms, professional engagement, and
        compliance with contract laws.
      </p>
    </div>
  );
};

export default Preview;
